import './Text.scss';
import React, { useEffect, useState } from 'react';

const TextComponent = ({ data, direction }) => {
  const [positionHorizontal, setPositionHorizontal] = useState('');
  const [positionVertical, setPositionVertical] = useState('');
  const [headline, setHeadline] = useState('');
  const [text, setText] = useState('');

  useEffect(() => {
    if (data.interactionData.positionHorizontal) {
      setPositionHorizontal(data.interactionData.positionHorizontal);
      setPositionVertical(data.interactionData.positionVertical);
      setHeadline(data.interactionData.headline);
      setText(data.interactionData.text);
    }
  }, [data]);

  return (
    <div className={`Text ${positionHorizontal} ${direction} ${positionVertical}`}>
      <p>{text}</p>
      <h1>{headline}</h1>
    </div>
  );
};

export default TextComponent;
